import tw from "twin.macro";

export const GroupCardsWrapper = tw.div`
flex
flex-col
gap-[0.5rem]
mt-[0.5rem]
`;
